import React, {Component} from 'react';
import {gpn} from "../GPN"
import Back from "../sections/Back";
import DateField from "../sections/MUI/DateField";
import jMoment from "jalali-moment";
import axios from "axios";
import Icon from "../sections/MUI/Icon";
import Req from "../req";
import {toast} from "react-toastify";

class MajidPoorsant extends Component {

    state = {
        list: [],

        start: jMoment().subtract(1, "jMonth").format("jYYYY/jMM/jDD"),
        end: jMoment().format("jYYYY/jMM/jDD")
    };

    componentDidMount() {
        let {start, end} = this.state;
        this.getItems(start, end);
    }

    getItems(start = "", end = "") {
        axios.post(`https://api.takinanoosh.ir/majid/poorsant`, JSON.stringify({start, end}), {
            headers: {
                "content-type": "application/json",
                "x-auth": "ImHere"
            }
        })
            .then(r => {
                this.setState({list: r.data || []});
            })
            .catch(err => {
            });
    }

    estelam(i = 0) {
        try {
            let {list = []} = this.state;
            let {phone} = list[i];
            toast.info("در حال استعلام ...", {autoClose: 700});
            Req.get(`/majid/poorsant/status?phone=${phone}`)
                .then(r => {
                    let users = list;
                    users[i].estelam = r ? r.status ? "yes" : "no" : "no";
                    this.setState({list: users});
                });
        } catch (err) {
        }
    }

    render() {
        let {list = [], start, end} = this.state;

        return (
            <>
                <Back {...this.props}/>
                <br/>
                <div className="poorsant">
                    <div className="row">
                        <div className="col-6">
                            <DateField value={start}
                                       onChange={(u, f) => {
                                           this.setState({start: f});
                                           this.getItems(f, end);
                                       }}
                                       label="از"/>
                        </div>
                        <div className="col-6">
                            <DateField value={end}
                                       onChange={(u, f) => {
                                           this.setState({end: f});
                                           this.getItems(start, f);
                                       }}
                                       label="تا"/>
                        </div>
                    </div>
                    <br/>
                    <div className="list">
                        {
                            list?.map((u, i) =>
                                <article key={"user" + i}>
                                    <div className="row">
                                        <div className="col">
                                            <p className="name"><span>نام:</span><span>{u.name}</span></p>
                                            <p className="phone"><span>شماره:</span><span>{u.phone}</span></p>
                                            <p className="date"><span>تاریخ ثبت:</span><span>{u.date}</span></p>
                                        </div>
                                        <div className="col-auto">
                                            <Icon className="refresh-icon" i="refresh" onClick={() => this.estelam(i)}/>
                                        </div>
                                    </div>
                                    {
                                        u.estelam ?
                                            <div className="estelam-ght">
                                                {
                                                    u.estelam === "yes" ?
                                                        <div style={{
                                                            fontWeight: "bold",
                                                            color: "#00770e"
                                                        }}>داخل قسطی تک یه غلطایی کرده</div>
                                                        :
                                                        <div style={{
                                                            fontWeight: "bold",
                                                            color: "#9e5306"
                                                        }}>خیالت راحت هیچ غلطی تکرده</div>
                                                }
                                            </div>
                                            : null
                                    }

                                </article>
                            )
                        }
                    </div>
                </div>
            </>
        );
    }
}


export default gpn(MajidPoorsant);